import { urlPath } from './utils-url-path.js';

class SortBy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => this.updateSortElements(event));
    this.defaultSortBy = this.getAttribute('data-sort-by-default');
  }

  /**
   * Update sort elements
   * @param {Object} event - Change event
   * @param {Object} event.target - Change event target
   *
   * @description Update all collection sort elements when the sort is changed
   */
  updateSortElements({ target: { value } }) {
    this.sortElements = this.sortElements || document.querySelectorAll('sort-by');

    // The 'element' variable is the current collection sort element. E.g. <sort-by>
    this.sortElements.forEach((element) => {
      // The 'select' variable is the select element inside the current collection sort element
      const select = element.querySelector('select');
      select.value = value;

      // Update the URL hash
      element.updateURL(value);
    });

    publish('sort:changed', {
      value,
    });
  }

  /**
   * Update URL
   * @param {String} value - URL value
   */
  updateURL(value) {
    const { searchParams } = new URL(window.location);
    searchParams.set('sort_by', value);
    searchParams.delete('page');

    // if value = default, remove the sort_by parameter from the URL
    if (this.defaultSortBy && value === this.defaultSortBy) {
      searchParams.delete('sort_by');
    }

    // Get the current path
    const path = urlPath();

    // Replace the current history state with the new search params, without reloading the page
    try {
      const newUrl = searchParams.size ? `${path}?${searchParams}` : path;
      history.replaceState(null, '', newUrl);
    } catch (error) {
      console.error('Error updating URL', error);
    }
  }
}

customElements.define('sort-by', SortBy);
